module.exports = __webpack_public_path__ + "static/poftabuna-6660117450cdf74d146c660a853ffde5.png";